module.exports = __webpack_public_path__ + "img/p1.bee46804.png";